import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { AccentButton } from '../../../../../generic/ui/Button'
import { FormFooter } from '../../../../../generic/ui/FormLayout'
import { IPackPalletItem } from '../../../../../modules/API/Packages/models/arizotLine'
import PackagesPickList, { IPackRow } from './packages/PackagesPickList'

type Props = {
  list: IPackPalletItem[],
  save: () => void,
  close: () => void
}

const CheckWindow = ({ list, save, close }: Props) => {
  const [t] = useTranslation('buttons')

  const rows: IPackRow[] = list.map((item) => ({
    id: item.id ?? `${item.PackID}`,
    name: item.Pack_Name?.trim() ?? '',
    type: item.Pack_Pallet ?? '',
    qty: item.Qty ?? 0,
    remark: item.Remark,
  }))

  return (
    <Panel>
      {/* Сводка перед отправкой: количества только читаются, править нечего. */}
      <PackagesPickList rows={rows} readOnly />

      <FormFooter>
        <AccentButton type='button' variant='ghost' onClick={close} fullWidth={false}>
          {t('close')}
        </AccentButton>
        <AccentButton type='button' onClick={save} fullWidth={false}>
          {t('save')}
        </AccentButton>
      </FormFooter>
    </Panel>
  )
}

export default CheckWindow

const Panel = styled.div`
  width: 100%;
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  direction: rtl;
`
